export { IrPage as default } from '@/components/pages/Contact/ir'
